import globalEN from './global.json';
import mainEN from './main.json';
import onboardingEN from './onboarding/first_step.json';
import rentalEN from './onboarding/estimate_page.json';
import onboardingSuccessEN from './onboarding/success_page.json';
import faqEN from './onboarding/faq.json';
import aboutEN from './company/about.json';
import partnerEN from './company/partner.json';
import blogEN from './company/blog.json';
import pricingEN from './company/pricing.json';
import insuranceEN from './company/insurance.json';
import securityEN from './company/security.json';
import listingsEN from './listings/list.json';
import destinationsSV from './listings/destinations.json';
import apartmentEN from './listings/apartment.json';
import successEN from './listings/success.json';
import errorEN from './error.json';
import formEN from './components/forms.json';
import sliderEN from './components/sliders.json';
import menuEN from './components/menu.json';
import guestsAuthEN from './guests/auth.json';

export const messages = {
  ...globalEN,
  main: mainEN,
  onboarding: onboardingEN,
  faq: faqEN,
  form: formEN,
  menu: menuEN,
  slider: sliderEN,
  rental: rentalEN,
  onboardingSuccess: onboardingSuccessEN,
  about: aboutEN,
  partner: partnerEN,
  blog: blogEN,
  pricing: pricingEN,
  insurance: insuranceEN,
  security: securityEN,
  listings: listingsEN,
  destinations: destinationsSV,
  apartment: apartmentEN,
  success: successEN,
  error: errorEN,
  auth: guestsAuthEN,
};
